import requestAction from '../../utils/requestAction'

export const fetchNotifications = (params: string, handleResponse?: (response: any) => void) =>
  requestAction('NOTIFICATION_LIST', params)(`notifications`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })


export const fetchPendingNotifications = (params: string, handleResponse?: (response: any) => void) =>
  requestAction('NOTIFICATION_PEND_LIST', params)(`notifications`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })


